import { executeCmdParam, GOBACK } from '@/utils/CmdUtils';

import './assets/css/base.scss';
import './assets/css/_var.css';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createHead } from '@unhead/vue/client';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { Dialog } from './plugins/iscool-dialog';

import App from './App.vue';
import router from './router';

const app = createApp(App);

app.use(VueAxios, axios);

// 配置 axios 实例作为 $http
app.config.globalProperties.$http = axios;

app.use(createHead());
app.use(createPinia());
app.use(router);
app.use(VueAxios, axios);
app.provide('axios', app.config.globalProperties.axios);

// 注册全局组件
// app.use(Toast)
app.use(Dialog);

// 客户端执行webview方法命名空间，声明action为全局命名空间，用于跟客户端交互
declare global {
  interface Window {
    action: {
      cmdCallback: () => void;
      goBack: () => void;
      setFontFamily?: (fontFamily: string) => void;
      query_permissions?: (type: string, state: string) => void;
      query_enabled?: any;
      showNavSharePopup?: (params: any) => void;
      paySuccess?: { callback: (...args: any[]) => void };
      callback?: (data: any) => void;
      renderShareUserInfo?: (data: any) => void;
      clipboardCallback?: (data: any) => void;
      jsInterface?: any;
      webkit?: any;
      [key: string]: any;
    };
  }
}

window.action = {
  cmdCallback: () => {},
  goBack: () => {},
} as any;

// 全局客户端后退调用方法
window.action.goBack = () => {
  executeCmdParam(GOBACK);
};

app.mount('#app');
